export const STORE_SITE_PAGE_ORDER = ['branding', 'home', 'about', 'contact'];

export const STORE_SITE_DEFAULTS = {
  branding: {
    logoImageUrl: '',
    logoAlt: '',
    logoWidthDesktop: 200,
    logoWidthMobile: 150,
    backgroundColor: '',
    wrapperColor: '',
    wrapperEnabled: true,
    navItems: [
      { label: 'Home', to: '/home' },
      { label: 'About', to: '/about' },
      { label: 'Contact', to: '/contact' },
      { label: 'Order Now', to: '/order' },
    ],
  },
  home: { customSections: [] },
  about: { customSections: [] },
  contact: { customSections: [] },
};

const isPlainObject = (value) => value && typeof value === 'object' && !Array.isArray(value);

export const deepMergeStoreSiteContent = (base, override) => {
  if (Array.isArray(base) || Array.isArray(override)) {
    return Array.isArray(override) ? override : base;
  }
  if (!isPlainObject(base) || !isPlainObject(override)) {
    return override ?? base;
  }
  const next = { ...base };
  Object.entries(override).forEach(([key, value]) => {
    next[key] = isPlainObject(value) && isPlainObject(base[key])
      ? deepMergeStoreSiteContent(base[key], value)
      : value;
  });
  return next;
};

export const cloneStoreSiteDefaults = () => JSON.parse(JSON.stringify(STORE_SITE_DEFAULTS));

export const buildStoreSiteContentMap = (rows = []) => {
  const defaults = cloneStoreSiteDefaults();
  rows.forEach((row) => {
    if (!row?.page_slug) return;
    const base = defaults[row.page_slug] || { customSections: [] };
    defaults[row.page_slug] = deepMergeStoreSiteContent(base, row.content || {});
  });
  return defaults;
};

export const normalizeBrandingNavItems = (branding) => {
  const items = Array.isArray(branding?.navItems) ? branding.navItems : STORE_SITE_DEFAULTS.branding.navItems;
  const legacyHidden = new Set(Array.isArray(branding?.hiddenPageKeys) ? branding.hiddenPageKeys : []);
  return items.map((item) => ({
    ...item,
    hidden: typeof item?.hidden === 'boolean' ? item.hidden : legacyHidden.has(String(item?.to || '').replace(/^\//, '').trim()),
  }));
};
